// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import { CREDITS_RESEARCH_WRITING, CREDITS_TRAILS } from "dail/constants/textVariables";


// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function AcknowledgementsCard() {

  return (
    <MKBox
      display="flex"
      alignItems="center"
      borderRadius="xl"
      my={2}
      py={6}
      sx={{
        backgroundColor: "#003c5a"
      }}
    >
      <Container>
        <Grid container item xs={10}>
          <MKTypography variant="h4" color="white" fontWeight="bold" sx={{ pb: 2 }}>
            Research Team and Acknowledgements
          </MKTypography>
          <MKTypography variant="body1" color="white" opacity={0.8} mb={2}>
            {CREDITS_RESEARCH_WRITING}
          </MKTypography>
          <MKTypography variant="body1" color="white" opacity={0.8} mb={2}>
            {CREDITS_TRAILS}
          </MKTypography>
        </Grid>
      </Container>
    </MKBox>
  );
}
export default AcknowledgementsCard;
